import { Button, ButtonGroup, NumericInput } from "@blueprintjs/core";

import { Range } from 'react-range';

import PageContext from "../Context/PageContext";
import { useContext, useEffect, useState } from "react";

import { ChromePicker, CompactPicker } from "react-color";
import $ from "jquery";

import { initMarkerSVG } from '../ElementConf/initMarker'
import { markerSVG } from "../Util/ActivitesUtil";
import { handleCloneAndCornerPosition } from "../Util/ElemUtil";
import { createOneValueItinerairetAction } from "../history/itineraire.history";
import { createMapElementAction, createMoveElementAction, createOneValueElementAction, CropState } from "../history/element.history";
import { isDesktop, isMobile, isTablet, useMobileOrientation } from "react-device-detect";
import SketchColor from "../Component/Card/SketchColor";

export default function AbsoluteMenuSection() {

    const { openAbsoluteMenuSection, setOpenAbsoluteMenuSection } = useContext(PageContext);

    return (
        <div className='positionSection'>
            <div className='close-side-menu' onClick={() => { if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('') }}>
                <img className="close-icon-side-menu" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/left-arrow.svg"}>
                </img>
            </div>
            {openAbsoluteMenuSection === 'position' && <PositionSection />}
            {openAbsoluteMenuSection.includes('marker') && <MarkerConfig openAbsoluteMenuSection={openAbsoluteMenuSection} />}
            {openAbsoluteMenuSection.includes('trace') && <TraceConfig openAbsoluteMenuSection={openAbsoluteMenuSection} />}
        </div>
    );
}

function PositionSection() {

    const { objItems, selectedItem, setObjItems, pageSize, mapTaille, setMapTaille, mapPosition, setMapPosition, mapIndex, setMapIndex, zoomValue, history } = useContext(PageContext);

    function changerLayer(string: any) {

        var indexSelectedItem = objItems.findIndex((x) => x.id === selectedItem.id)

        if (indexSelectedItem > -1) {

            var toIndex = null;

            if (string === 'up') toIndex = indexSelectedItem + 1;
            else if (string === 'down') toIndex = indexSelectedItem - 1;
            else if (string === 'last') toIndex = 0;
            else if (string === 'first') toIndex = objItems.length - 1;

            //on est obligé de faire une copie pour déclencher un re render
            //peut etre source de consommation mémoire élevée ? test memory dans chrome c'est ok
            if (toIndex != null && toIndex >= 0) {
                let duplicationObj = [...objItems];

                const element = duplicationObj.splice(indexSelectedItem, 1)[0];

                if (toIndex != null) duplicationObj.splice(toIndex, 0, element);

                if (setObjItems != null) {
                    setObjItems(duplicationObj);
                }

                let action = createOneValueElementAction({
                    target: "elem-ordre",
                    item: null,
                    from: objItems,
                    to: duplicationObj,
                    context: { setObjItems }
                });

                history.add(action);
            }

        }
        else if (selectedItem.id === 'mapbox-id') {
            if (setMapIndex != null) {
                var to = 0;
                if (string === 'up') { setMapIndex(mapIndex + 1); to = mapIndex + 1; }
                else if (string === 'down') { setMapIndex(mapIndex - 1); to = mapIndex - 1; }
                else if (string === 'last') { setMapIndex(0); to = 0; }
                else if (string === 'first') { toIndex = setMapIndex(objItems.length); to = objItems.length; }

                let action = createOneValueElementAction({
                    target: "map-ordre",
                    item: null,
                    from: mapIndex,
                    to: to,
                    context: { setMapIndex }
                });

                history.add(action);
            }
        }

    }

    function updatePositionElement(string: any) {

        const item = objItems.find(item => item.id === selectedItem.id);
        var itemHeight = 0;
        var itemWidth = 0;
        var x = 0, y = 0;
        //var backPosition = { x: 0, y: 0, width: 0, height: 0, zoomValue, crop: null };
        var backPosition: CropState = {
            x: 0,
            y: 0,
            width: 0,
            height: 0,
            zoomValue,
            crop: null,
        };
        var backPositionMap = { x: null, y: null, width: null, height: null };

        if (selectedItem.id !== 'mapbox-id') {
            //backPosition = { x: item.x, y: item.y, width: item.width, height: item.height, zoomValue, crop: cloneCrop(item.crop) }
            backPosition.x = item.x;
            backPosition.y = item.y;
            backPosition.width = item.width;
            backPosition.height = item.height;
            backPosition.crop = cloneCrop(item.crop);
        }
        else {
            backPositionMap = { x: mapPosition.x, y: mapPosition.y, width: mapTaille.width, height: mapTaille.height }
        }

        if (selectedItem != null && item != null) {
            if (item.height !== undefined) { itemHeight = (typeof item.height === "string") ? item.height.replace("px", "") : item.height; }
            else { itemHeight = $('#' + item.id).height() as number; }

            if (item.width !== undefined) { itemWidth = (typeof item.width === "string") ? item.width.replace("px", "") : item.width; }
            else { itemWidth = $('#' + item.id).width() as number; }
        }

        if (string === 'verticalement') {
            if (selectedItem != null && item != null) {
                item.y = pageSize.height / 2 - itemHeight / 2;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                y = pageSize.height / 2 - mapTaille.height / 2;
                x = mapPosition.x;
                if (setMapPosition != null) setMapPosition({ x: mapPosition.x, y: y })
            }
        }
        else if (string === 'horizontalement​') {
            if (selectedItem != null && item != null) {
                item.x = pageSize.width / 2 - itemWidth / 2;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                x = pageSize.width / 2 - mapTaille.width / 2;
                y = mapPosition.y;
                if (setMapPosition != null) setMapPosition({ x: x, y: mapPosition.y })
            }
        }
        else if (string === 'gauche') {
            if (selectedItem != null && item != null) {
                item.x = 0;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                x = 0; y = mapPosition.y;
                if (setMapPosition != null) setMapPosition({ x: 0, y: mapPosition.y })
            }
        }
        else if (string === 'droite') {
            if (selectedItem != null && item != null) {
                item.x = pageSize.width - itemWidth;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                x = pageSize.width - mapTaille.width;
                y = mapPosition.y;
                if (setMapPosition != null) setMapPosition({ x: x, y: mapPosition.y })
            }
        }
        else if (string === 'haut') {
            if (selectedItem != null && item != null) {
                item.y = 0;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                x = mapPosition.x;
                y = 0;
                if (setMapPosition != null) setMapPosition({ x: mapPosition.x, y: 0 })
            }
        }
        else if (string === 'bas') {
            if (selectedItem != null && item != null) {
                item.y = pageSize.height - itemHeight;
                item.rnd.current.updatePosition({ x: item.x, y: item.y });
            }
            else if (selectedItem.id === 'mapbox-id') {
                y = pageSize.height - mapTaille.height;
                x = mapPosition.x;
                if (setMapPosition != null) setMapPosition({ x: mapPosition.x, y: y })
            }
        }

        if (selectedItem != null && selectedItem.id === 'mapbox-id') {
            $("#clone-" + selectedItem!.id).css({ top: y, left: x, width: mapTaille.width, height: mapTaille.height, position: 'absolute' });
        }
        else if (selectedItem != null && item != null) {
            //replace and size corner and move card          
            handleCloneAndCornerPosition(item, { x: item.x, y: item.y }, null, null, true, zoomValue);
        }

        if (selectedItem.id !== 'mapbox-id') {
            var action = createMoveElementAction(
                item,
                backPosition,
                { x: item.x, y: item.y, width: item.width, height: item.height, zoomValue, crop: cloneCrop(item.crop) }
            );

            history.add(action);
        }
        else {
            var isSelectedItem = selectedItem.id === "mapbox-id" ? true : false;
            var actionMap = createMapElementAction(
                backPositionMap,
                { x: x, y: y, width: mapTaille.width, height: mapTaille.height },
                { setMapPosition, setMapTaille, isSelectedItem }
            );

            history.add(actionMap);
        }
    }

    function cloneCrop(crop: any) {
        if (crop == null) return null;

        return {
            cropPart: { ...crop.cropPart },
            fullImage: { ...crop.fullImage },
            isCrop: crop.isCrop
        };

    }

    return (
        <div className=''>
            <div style={{ textAlign: 'center', margin: '5px' }}>
                <button className='position-button main-button2' onClick={() => changerLayer('last')}><img alt="last" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/send_backward.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Arrière-Plan</label></button>
                <button className='position-button main-button2' onClick={() => changerLayer('down')}><img alt="down" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/send_backward.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Arrière</label></button>
                <button className='position-button main-button2' onClick={() => changerLayer('up')}><img alt="up" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/send_forward.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Avant</label></button>
                <button className='position-button main-button2' onClick={() => changerLayer('first')}><img alt="first" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/send_forward.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Avant-Plan</label></button>
            </div>
            <div style={{ textAlign: 'center', margin: '5px' }}>
                <h3>Centrer</h3>
                <button className='position-button main-button2' onClick={() => updatePositionElement('verticalement')}><img alt="verticalement" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/align_vertical.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Verticalement</label></button>
                <button className='position-button main-button2' onClick={() => updatePositionElement('horizontalement​')}><img alt="horizontalement​" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/align_horizontal.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Horizontalement​</label></button>
            </div>

            <div style={{ textAlign: 'center', margin: '5px' }}>
                <h3>Aligner sur la page</h3>
                <button className='position-button main-button2' onClick={() => updatePositionElement('haut')}><img alt="haut" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/haut.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Haut</label></button>
                <button className='position-button main-button2' onClick={() => updatePositionElement('bas')}><img alt="bas" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/bas.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Bas</label></button>
                <button className='position-button main-button2' onClick={() => updatePositionElement('gauche')}><img alt="gauche" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/gauche.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Gauche</label></button>
                <button className='position-button main-button2' onClick={() => updatePositionElement('droite')}><img alt="droite" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-design/droite.png"} style={{ height: '15px', marginRight: '5px' }}></img> <label>Droite</label></button>
            </div>
        </div>
    );
}

// A DEPLACER DANS UTIL MARKER ou un truc comme ça
function MarkerConfig(props: any) {

    //Use to make reload component
    const openAbsoluteMenuSection = props.openAbsoluteMenuSection;

    const { mapListPoint, setOpenAbsoluteMenuSection, history } = useContext(PageContext);

    const idMarker = openAbsoluteMenuSection.slice(openAbsoluteMenuSection.lastIndexOf('-') + 1);
    const item = mapListPoint.find(item => item.id === idMarker);

    const [sizeMarker, setSizeMarker] = useState(item.markerStyle.size);
    const [sizeMarkerTxt, setSizeMarkerTxt] = useState(item.markerTxtStyle.size);
    const [colorMarker, setColorMarker] = useState(item.markerStyle.color);
    const [colorMarkerTxt, setColorMarkerTxt] = useState(item.markerTxtStyle.color);
    const [classMarker, setClassMarker,] = useState(item.markerStyle.class);
    const [activeItem, setActiveItem] = useState("");

    const { isLandscape } = useMobileOrientation();

    useEffect(() => {

        //use to refresh values when open new marker config
        setSizeMarker(item.markerStyle.size);
        setColorMarker(item.markerStyle.color);
        setClassMarker(item.markerStyle.class);

        setSizeMarkerTxt(item.markerTxtStyle.size);
        setColorMarkerTxt(item.markerTxtStyle.color);

        switch (item.labelPosition) {
            case 'bottom-right':
                setActiveItem('position1');
                break;
            case 'bottom':
                setActiveItem('position2');
                break;
            case 'bottom-left':
                setActiveItem('position3');
                break;
            case 'right':
                setActiveItem('position4');
                break;
            case 'left':
                setActiveItem('position6');
                break;
            case 'top-right':
                setActiveItem('position7');
                break;
            case 'top':
                setActiveItem('position8');
                break;
            case 'top-left':
                setActiveItem('position9');
                break;
            default:
                setActiveItem('position8');
        }

    }, [openAbsoluteMenuSection]);

    //en écoutant les valeurs des marqueurs qui change via item, on évite de passer les fonctions setColorMarker à l'historique. Si on modifie la valeur dans l'historique et que c'est absolute sectione est ouvert, alors on aura le champ qui se met à jour
    //Evite de passer les fonctions setColorMarker au contexte globale, on prend le problème dans l'autre sens.
    useEffect(() => {
        setColorMarker(item.markerStyle.color);
    }, [item.markerStyle.color]);
    useEffect(() => {
        setSizeMarker(item.markerStyle.size);
    }, [item.markerStyle.size]);
    useEffect(() => {
        setColorMarkerTxt(item.markerTxtStyle.color);
    }, [item.markerTxtStyle.color]);
    useEffect(() => {
        setSizeMarkerTxt(item.markerTxtStyle.size);
    }, [item.markerTxtStyle.size]);
    useEffect(() => {
        $('.positionnement-label-item').removeClass("active");
        var pos = '';

        switch (item.labelPosition) {
            case 'bottom-right': pos = 'position1'; break;
            case 'bottom': pos = 'position2'; break;
            case 'bottom-left': pos = 'position3'; break;
            case 'right': pos = 'position4'; break;
            case 'left': pos = 'position6'; break;
            case 'top-right': pos = 'position7'; break;
            case 'top': pos = 'position8'; break;
            case 'top-left': pos = 'position9'; break;
            default: pos = 'position9';
        }

        $("." + pos + " path").addClass('active');


    }, [item.markerTxt._anchor]);
    useEffect(() => {
        $('.marker-selector-child').removeClass("selected");
        $('.marker-selector-child .' + item.markerType).parent().addClass('selected');
    }, [item.markerType]);


    /*function removeClassByPrefix(node: any, prefix: any) {
        var regx = new RegExp('\\b' + prefix + '[^ ]*[ ]?\\b', 'g');
        node.className = node.className.replace(regx, '');
        return node;
    }*/

    function changeMarker(type: any) {
        var itemMakerDiv = item.marker.getElement().querySelector('div');

        //SVG : on utilise le viewport pour set la position de l'élement
        //pour avoir les bonnes dimensions du svg
        //https://vectorpaint.yaks.co.nz/

        let from = item.markerType;

        itemMakerDiv.innerHTML = markerSVG(type, item.markerStyle.color);

        //Dès qu'on change de marker, on set la taille à 100 pixel pour qu'il apparaisse plus
        if (type !== 'marker-circle') {
            item.markerStyle.size = 100;
            itemMakerDiv.style.width = '100px';
            itemMakerDiv.style.height = '100px';
            //To reload component
            setSizeMarker(100);
        }
        else {
            item.markerStyle.size = 50;
            itemMakerDiv.style.width = '50px';
            itemMakerDiv.style.height = '50px';
            //To reload component
            setSizeMarker(50);
        }

        item.markerStyle.class = type;
        item.markerType = type;

        //To reload component
        setClassMarker(type);

        if (from !== item.markerType) {
            let action = createOneValueItinerairetAction({
                target: "marker-item",
                item: item,
                from,
                to: item.markerType
            });

            history.add(action);
        }
    }

    function labelUpdatePosition(event: any, position: any) {

        $('.positionnement-label-item').removeClass("active");
        event.currentTarget.querySelector('path').classList.add('active');

        let from = item.markerTxt._anchor;

        switch (position) {
            case 'position1':
                item.markerTxt._anchor = 'bottom-right';
                item.labelPosition = 'bottom-right';
                break;
            case 'position2':
                item.markerTxt._anchor = 'bottom';
                item.labelPosition = 'bottom';
                break;
            case 'position3':
                item.markerTxt._anchor = 'bottom-left';
                item.labelPosition = 'bottom-left';
                break;
            case 'position4':
                item.markerTxt._anchor = 'right';
                item.labelPosition = 'right';
                break;
            case 'position6':
                item.markerTxt._anchor = 'left';
                item.labelPosition = 'left';
                break;
            case 'position7':
                item.markerTxt._anchor = 'top-right';
                item.labelPosition = 'top-right';
                break;
            case 'position8':
                item.markerTxt._anchor = 'top';
                item.labelPosition = 'top';
                break;
            case 'position9':
                item.markerTxt._anchor = 'top-left';
                item.labelPosition = 'top-left';
                break;
            default:
                console.log('Sorry, we are out');
        }

        item.markerTxt._update();

        let action = createOneValueItinerairetAction({
            target: "label-position",
            item: item,
            from,
            to: item.markerTxt._anchor
        });

        history.add(action);

    }


    function widthChange(event: number) {

        if (event > 300) event = 300;

        let from = item.markerStyle.size;
        var itemMakerDiv = item.marker.getElement().querySelector('div');

        item.markerStyle.size = event;
        itemMakerDiv.style.width = event + 'px';
        itemMakerDiv.style.height = event + 'px';

        //To reload component
        setSizeMarker(event);

        let action = createOneValueItinerairetAction({
            target: "marker-size",
            item: item,
            from,
            to: event
        });

        history.add(action);
    }

    function widthChangeTxt(event: number) {

        let from = item.markerTxtStyle.size;

        var itemMakerTxt = item.markerTxt.getElement();

        item.markerTxtStyle.size = event;
        itemMakerTxt.style['font-size'] = event + 'px';

        //To reload component
        setSizeMarkerTxt(event)

        let action = createOneValueItinerairetAction({
            target: "label-size",
            item: item,
            from,
            to: event
        });

        history.add(action);
    }

    function handleColor(color: any) {
        let from = item.markerStyle.color;

        var itemMakerDivSvg = item.marker.getElement().querySelector('div').querySelector('svg');
        var itemMakerDivDiv = item.marker.getElement().querySelector('div').querySelector('div');

        item.markerStyle.color = color.hex;
        if (itemMakerDivDiv != null) itemMakerDivDiv.style.backgroundColor = color.hex;
        else itemMakerDivSvg.style.fill = color.hex;

        //To reload component
        setColorMarker(color.hex)

        let action = createOneValueItinerairetAction({
            target: "marker-color",
            item: item,
            from,
            to: color.hex
        });

        history.add(action);
    }

    function handleColorTxt(color: any) {
        let from = item.markerTxtStyle.color;

        var itemMakerLabel = item.markerTxt.getElement();

        item.markerTxtStyle.color = color.hex;
        itemMakerLabel.style.color = color.hex;

        //To reload component
        setColorMarkerTxt(color.hex)

        let action = createOneValueItinerairetAction({
            target: "label-color",
            item: item,
            from,
            to: color.hex
        });

        history.add(action);
    }

    const fondCarteElement = initMarkerSVG.map((marker: any) =>
        <div className={classMarker === marker[0] ? 'marker-selector-child selected' : 'marker-selector-child'} onClick={() => changeMarker(marker[0])}>
            <div className={' ' + marker[0]} dangerouslySetInnerHTML={{ __html: marker[1] }}></div>
        </div>
    );

    return (

        <div>
            <div className="close-cont">
                {/*<button className="btn-with-nothing" onClick={() => { if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('') }} >
                    <img alt="Fermer" className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/croix.svg"}></img>
                </button>
                <div className='close-side-menu' onClick={() => { if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('') }}>
                    <img className="close-icon-side-menu" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/left-arrow.svg"}>
                    </img>
                </div>*/}
            </div>

            <h4>Icônes du parcours</h4>
            <div className='marker-selector'>
                {fondCarteElement}

            </div>

            <h4>Taille de l’icône</h4>
            <div className="input-hw-map">
                <Slider
                    fn={widthChange}
                    refSize={sizeMarker}
                    min={0}
                    max={300}
                />
                <NumericInput id="forme_size"
                    onValueChange={widthChange}
                    value={sizeMarker}
                    small={true} stepSize={1}
                    max={300}
                    buttonPosition={'none'}
                    rightElement={<div className="num-input">px</div>} />
            </div>

            <h4>Couleur de l’icône</h4>
            <div className="trace-color">
                {(isDesktop || isTablet || (isMobile && isLandscape)) && <ChromePicker
                    color={colorMarker}
                    onChange={handleColor} disableAlpha={true} />}

                {((isMobile && !isTablet && !isLandscape)) && <CompactPicker
                    color={colorMarker}
                    onChange={handleColor} />}
            </div>

            <div className="separateur"></div>
            <div className="texte-abs-section">Choisissez la position, la taille et la couleur de votre libellé...</div>

            <h4>Position du libellé</h4>
            <div className="positionnement-label">
                <div onClick={(event) => labelUpdatePosition(event, 'position1')} className="pos-label-item"> <ArrowSVG css={"position1"} active={activeItem === "position1" ? true : false} /></div>
                <div onClick={(event) => labelUpdatePosition(event, 'position2')} className="pos-label-item"> <ArrowSVG css={"position2"} active={activeItem === "position2" ? true : false} /> </div>
                <div onClick={(event) => labelUpdatePosition(event, 'position3')} className="pos-label-item"> <ArrowSVG css={"position3"} active={activeItem === "position3" ? true : false} /> </div>

                <div onClick={(event) => labelUpdatePosition(event, 'position4')} className="pos-label-item"> <ArrowSVG css={"position4"} active={activeItem === "position4" ? true : false} /> </div>
                <div> </div>
                <div onClick={(event) => labelUpdatePosition(event, 'position6')} className="pos-label-item"> <ArrowSVG css={"position6"} active={activeItem === "position6" ? true : false} /> </div>

                <div onClick={(event) => labelUpdatePosition(event, 'position7')} className="pos-label-item"> <ArrowSVG css={"position7"} active={activeItem === "position7" ? true : false} /> </div>
                <div onClick={(event) => labelUpdatePosition(event, 'position8')} className="pos-label-item"> <ArrowSVG css={"position8"} active={activeItem === "position8" ? true : false} /> </div>
                <div onClick={(event) => labelUpdatePosition(event, 'position9')} className="pos-label-item"> <ArrowSVG css={"position9"} active={activeItem === "position9" ? true : false} /> </div>
            </div>

            <h4>Taille du libellé</h4>
            <div className="input-hw-map">
                <Slider
                    fn={widthChangeTxt}
                    refSize={sizeMarkerTxt}
                    min={0}
                    max={100}
                />
                <NumericInput id="forme_size"
                    onValueChange={widthChangeTxt}
                    value={sizeMarkerTxt}
                    small={true} stepSize={1}
                    max={100}
                    buttonPosition={'none'}
                    rightElement={<div className="num-input">px</div>} />
            </div>

            <h4>Couleur du libellé</h4>
            <div className="trace-color">
                {(isDesktop || isTablet || (isMobile && isLandscape)) && <ChromePicker
                    color={colorMarkerTxt}
                    onChange={handleColorTxt} disableAlpha={true} />}

                {((isMobile && !isTablet && !isLandscape)) && <CompactPicker
                    color={colorMarkerTxt}
                    onChange={handleColorTxt} />}
            </div>

            <h4>Police du libellé</h4>
            <FontPickerMarker item={item} key={item.id + 'police-marker'} />


        </div>
    )
}

function ArrowSVG(props: any) {
    var css = props.css;
    var isActive = props.active != undefined ? props.active : false;

    return (
        <svg className={css} version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px"
            width={(isDesktop || isTablet) ? "20px" : "30px"} height={(isDesktop || isTablet) ? "20px" : "30px"} viewBox="0 0 40 40" >
            <g>
                <path className={"arrow-positionnement positionnement-label-item " + (isActive ? "active" : "")} fill="#AB7C94" d="M20,0C8.973,0,0,8.973,0,20c0,11.027,8.973,20,20,20c11.027,0,20-8.973,20-20C40,8.973,31.027,0,20,0z M28.796,21.477
		l-5.332,6.279c-0.45,0.531-1.094,0.805-1.739,0.805c-0.521,0-1.047-0.179-1.477-0.543c-0.96-0.813-1.078-2.254-0.263-3.215
		l2.142-2.521h-9.186c-1.26,0-2.281-1.021-2.281-2.281s1.021-2.281,2.281-2.281h9.186l-2.142-2.521
		c-0.815-0.961-0.697-2.4,0.263-3.217c0.96-0.815,2.4-0.697,3.216,0.264l5.332,6.279C29.52,19.375,29.52,20.625,28.796,21.477z"/>
            </g>
        </svg>
    )
}

function FontPickerMarker(props: any) {

    const item = props.item;

    const { selectedItem, zoomValue, history } = useContext(PageContext);

    const [fontWeightMarkerTxt, setFontWeightMarkerTxt] = useState(item.markerTxtStyle.fontWeight != null ? item.markerTxtStyle.fontWeight : null);
    const [fontStyleMarkerTxt, setFontStyleMarkerTxt] = useState(item.markerTxtStyle.fontStyle != null ? item.markerTxtStyle.fontStyle : null);
    const [textDecorationMarkerTxt, setTextDecorationMarkerTxt] = useState(item.markerTxtStyle.textDecoration != null ? item.markerTxtStyle.textDecoration : null);
    const [strokeWidthMarkerTxt, setStrokeWidthMarkerTxt] = useState(item.markerTxtStyle['-webkit-text-stroke-width'] != null ? item.markerTxtStyle['-webkit-text-stroke-width'] : null);
    const [strokeColorMarkerTxt, setStrokeColorMarkerTxt] = useState(item.markerTxtStyle['-webkit-text-stroke-color'] != null ? item.markerTxtStyle['-webkit-text-stroke-color'] : null);
    const [fontFamilyMarkerTxt, setFontFamilyMarkerTxt] = useState(item.markerTxtStyle['font-family'] != null ? item.markerTxtStyle['font-family'] : null);

    useEffect(() => {
        setFontWeightMarkerTxt(item.markerTxtStyle.fontWeight);
    }, [item.markerTxtStyle.fontWeight]);
    useEffect(() => {
        setFontStyleMarkerTxt(item.markerTxtStyle.fontStyle);
    }, [item.markerTxtStyle.fontStyle]);
    useEffect(() => {
        setTextDecorationMarkerTxt(item.markerTxtStyle.textDecoration);
    }, [item.markerTxtStyle.textDecoration]);
    useEffect(() => {
        setStrokeWidthMarkerTxt(item.markerTxtStyle['-webkit-text-stroke-width']);
    }, [item.markerTxtStyle['-webkit-text-stroke-width']]);
    useEffect(() => {
        setStrokeColorMarkerTxt(item.markerTxtStyle['-webkit-text-stroke-color']);
    }, [item.markerTxtStyle['-webkit-text-stroke-color']]);
    useEffect(() => {
        setFontFamilyMarkerTxt(item.markerTxtStyle['font-family']);
    }, [item.markerTxtStyle['font-family']]);

    const fontArray = ["Abril Fatface",
        "Amatic SC",
        "Alfa Slab One",
        "Arial",
        "Arial Black",
        "Arimo",
        "Audiowide",
        "Bauhaus",
        "Baskerville",
        "Bebas Neue",
        "Bruno Ace",
        "Cabin Sketch",
        "Cinzel",
        "Comic Sans MS",
        "Courier",
        "Coolvetica",
        "Creepster",
        "DM Serif Text",
        "Edo",
        "Epilogue",
        "Exo",
        "Geist",
        "Georgia",
        "Gruppo",
        "Hachi Maru Pop",
        "Helvetica",
        "Homemade Apple",
        "IBM Plex Mono",
        "Impact",
        "Indie Flower",
        "Instrument Sans",
        "Kalnia",
        "Kodchasan",
        "Koulen",
        "Krona One",
        "Lexend Exa",
        "Limelight",
        "Londrina Shadow",
        "Michroma",
        "Monaco",
        "Monoton",
        "Montserrat",
        "Nothing You Could Do",
        "Open Sans",
        "Orbitron",
        "Oswald",
        "Outfit",
        "Palatino",
        "Patrick Hand SC",
        "Poiret One",
        "Poppins",
        "Questrial",
        "Raleway",
        "Reem Kufi",
        "Righteous",
        "Roboto",
        "Rubik Mono One",
        "Sanchez",
        "Shadows Into Light",
        "Sora",
        "Special Elite",
        "Spinnaker",
        "Syncopate",
        "Times New Roman",
        "Trebuchet MS",
        "Urbanist",
        "Vibes",
        "Wire One",
        "Zalando Sans Expanded"];

    /*const fontOption = fontArray.map((font: any) => {
        var isFont = false//selectedItem.style.fontFamily.includes(font);
        return <div className={'font-option' + (isFont ? ' active-font' : '')} style={{ fontFamily: font, flex: 'none', margin: '5px', padding: '5px' }} key={font} onClick={(e) => selectFont(e, font)} >{font}</div>
    });*/

    /**/const fontOption = fontArray.map((font: any) => {
            return <option value={font} style={{ fontFamily: font }} key={font}>{font}</option>
        });

    const fontOptionMobile = fontArray.map((font: any) => {
        var isFont = item.markerTxtStyle.fontFamily != null && item.markerTxtStyle.fontFamily.includes(font);
        return <div className={'font-option' + (isFont ? ' active-font' : '')} style={{ fontFamily: font, flex: 'none', margin: '5px', padding: '5px' }} key={font} onClick={(e) => selectFont(e, font)} >{font}</div>
    });

    const selectFont = (event: any, fontParam: any) => {
        //remove active class
        $('.font-option').removeClass('active-font');
        //active new
        event.target.className += " active-font";

        const value = fontParam;
        let from = item.markerTxtStyle.fontFamily;
        var itemMakerLabel = item.markerTxt.getElement();

        item.markerTxtStyle.fontFamily = value;
        itemMakerLabel.style.fontFamily = value;

        let action = createOneValueItinerairetAction({
            target: "marker-font",
            item: item,
            from,
            to: value
        });

        history.add(action);

    };

    /**/const selectChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
        const value = event.target.value;
        let from = item.markerTxtStyle.fontFamily;
        var itemMakerLabel = item.markerTxt.getElement();

        item.markerTxtStyle.fontFamily = value;
        itemMakerLabel.style.fontFamily = value;

        let action = createOneValueItinerairetAction({
            target: "marker-font",
            item: item,
            from,
            to: value
        });

        history.add(action);

    };

    function setTextFont(e: String) {
        /* To set changed property to listItems*/

        var itemMakerLabel = item.markerTxt.getElement();

        if (e == 'bold') {
            if (item.markerTxtStyle.fontWeight == 'bold') { item.markerTxtStyle.fontWeight = 'normal'; itemMakerLabel.style['font-weight'] = 'normal'; setFontWeightMarkerTxt("normal") }
            else { item.markerTxtStyle.fontWeight = 'bold'; itemMakerLabel.style['font-weight'] = 'bold'; setFontWeightMarkerTxt("bold") }
        }
        else if (e == 'italic') {
            if (item.markerTxtStyle.fontStyle == 'italic') { item.markerTxtStyle.fontStyle = 'normal'; itemMakerLabel.style['font-style'] = 'normal'; setFontStyleMarkerTxt("normal") }
            else { item.markerTxtStyle.fontStyle = 'italic'; itemMakerLabel.style['font-style'] = 'italic'; setFontStyleMarkerTxt("italic") }
        }
        else if (e == 'underline') {
            if (item.markerTxtStyle.textDecoration == 'underline') { item.markerTxtStyle.textDecoration = 'none'; itemMakerLabel.style['text-decoration'] = 'none'; setTextDecorationMarkerTxt("none") }
            else { item.markerTxtStyle.textDecoration = 'underline'; itemMakerLabel.style['text-decoration'] = 'underline'; setTextDecorationMarkerTxt("underline") }
        }
    }

    function setContourLabel(e: String) {
        /* To set changed property to listItems*/

        var itemMakerLabel = item.markerTxt.getElement();
        let from = item.markerTxtStyle['-webkit-text-stroke-width'] != null ? item.markerTxtStyle['-webkit-text-stroke-width'] : '0px';

        if (e == 'sans') {
            item.markerTxtStyle['-webkit-text-stroke-width'] = '0px'; itemMakerLabel.style['-webkit-text-stroke-width'] = '0px';
            setStrokeWidthMarkerTxt("0px");
        }
        else if (e == 'fin') {
            if (item.markerTxtStyle['-webkit-text-stroke-width'] == null) {
                //set couleur if null
                item.markerTxtStyle['-webkit-text-stroke-color'] = 'white';
                itemMakerLabel.style['-webkit-text-stroke-color'] = 'white';
            }
            item.markerTxtStyle['-webkit-text-stroke-width'] = '1px'; itemMakerLabel.style['-webkit-text-stroke-width'] = '1px';
            setStrokeWidthMarkerTxt("1px");
        }
        else if (e == 'epais') {
            if (item.markerTxtStyle['-webkit-text-stroke-width'] == null) {
                //set couleur if null
                item.markerTxtStyle['-webkit-text-stroke-color'] = 'white';
                itemMakerLabel.style['-webkit-text-stroke-color'] = 'white';
            }
            item.markerTxtStyle['-webkit-text-stroke-width'] = '3px'; itemMakerLabel.style['-webkit-text-stroke-width'] = '3px';
            setStrokeWidthMarkerTxt("3px");
        }

        let action = createOneValueItinerairetAction({
            target: "marker-contour",
            item: item,
            from,
            to: item.markerTxtStyle['-webkit-text-stroke-width']
        });

        history.add(action);
    }

    function handleColorTxt(color: any) {
        let from = item.markerTxtStyle.color;

        var itemMakerLabel = item.markerTxt.getElement();

        item.markerTxtStyle['-webkit-text-stroke-color'] = color.hex;
        itemMakerLabel.style['-webkit-text-stroke-color'] = color.hex;

        /*
        //To reload component
        setColorMarkerTxt(color.hex)

        let action = createOneValueItinerairetAction({
            target: "label-color",
            item: item,
            from,
            to: color.hex
        });

        history.add(action);
        */
    }

    return (
        <div>
            {(isMobile || isTablet) && <div className='font-mobile-container' style={{ marginBottom: '10px' }}>
                {fontOptionMobile}
            </div>}
            {(isDesktop) && <select name="fonts" id="font-select" value={item.markerTxtStyle.fontFamily} onChange={selectChange} style={{ margin: '8px 0', padding: '5px', maxWidth: '100%', borderRadius: '5px' }}>
                {fontOption}
            </select >}

            <div>
                <ButtonGroup>
                    <Button className='' onClick={() => setTextFont('bold')} active={fontWeightMarkerTxt === 'bold' ? true : false} icon="bold"></Button>
                    <Button className='' onClick={() => setTextFont('italic')} active={fontStyleMarkerTxt === 'italic' ? true : false} icon="italic"></Button>
                    <Button className='' onClick={() => setTextFont('underline')} active={textDecorationMarkerTxt === 'underline' ? true : false} icon="underline"></Button>
                </ButtonGroup>
            </div>

            <h5>Contours du libellé</h5>
            <div>
                <ButtonGroup>
                    <Button className='' onClick={() => setContourLabel('sans')} active={(strokeWidthMarkerTxt == "0px" || strokeWidthMarkerTxt == null) ? true : false} >Sans</Button>
                    <Button className='' onClick={() => setContourLabel('fin')} active={strokeWidthMarkerTxt == "1px" ? true : false}>Fin</Button>
                    <Button className='' onClick={() => setContourLabel('epais')} active={strokeWidthMarkerTxt == "3px" ? true : false} >Épais</Button>
                </ButtonGroup>
            </div>

            {isDesktop && <div className="label-contour-couleur">
                <h5>Couleur du contour</h5>
                <SketchColor key={item.id} elem={'marker-element-contour'} marker={item} color={item.markerTxtStyle['-webkit-text-stroke-color'] != null ? item.markerTxtStyle['-webkit-text-stroke-color'] : 'white'} />
            </div>}

            {(isMobile) && <div>
                <h5>Couleur du contour</h5>
                <CompactPicker
                    color={item.markerTxtStyle['-webkit-text-stroke-color'] != null ? item.markerTxtStyle['-webkit-text-stroke-color'] : 'white'}
                    onChange={handleColorTxt} />
            </div>}
        </div>
    );
}

//{ process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/right-arrow-in-a-circle.svg" }

const TraceConfig = (props: any) => {

    //Use to make reload component
    const openAbsoluteMenuSection = props.openAbsoluteMenuSection;

    //const [isTraceOpen, setIsTraceOpen] = useState(true);

    const { mapListTrace, setOpenAbsoluteMenuSection, history } = useContext(PageContext);

    const idTrace = openAbsoluteMenuSection.slice(openAbsoluteMenuSection.lastIndexOf('-') + 1);
    const item = mapListTrace.find(item => item.id === idTrace);

    const [sizeTrace, setSizeTrace] = useState(item.traceStyle["line-width"]);
    const [colorTrace, setColorTrace] = useState(item.traceStyle["line-color"]);

    const [pointilleTrace, setPointilleTrace,] = useState(item.traceStyle['"line-dasharray"']);
    const [isActivePointilleTrace, setIsActivePointilleTrace] = useState(() => {
        switch (JSON.stringify(item.traceStyle["line-dasharray"])) {
            case JSON.stringify([1]):
                return 0;
            case JSON.stringify([1, 1]):
                return 1;
            case JSON.stringify([3, 2]):
                return 2;
            default:
                return 0;
        }
    });

    //to handle history reload
    useEffect(() => {
        setColorTrace(item.traceStyle["line-color"]);
    }, [item.traceStyle["line-color"]]);
    useEffect(() => {
        setSizeTrace(item.traceStyle["line-width"]);
    }, [item.traceStyle["line-width"]]);
    useEffect(() => {
        setPointilleTrace(item.traceStyle["line-dasharray"]);
        setIsActivePointilleTrace(transformPointilleTrace(item.traceStyle["line-dasharray"]));
    }, [item.traceStyle["line-dasharray"]]);

    function transformPointilleTrace(elem: any) {
        switch (JSON.stringify(elem)) {
            case JSON.stringify([1]):
                return 0;
            case JSON.stringify([1, 1]):
                return 1;
            case JSON.stringify([3, 2]):
                return 2;
            default:
                return 0;
        }
    }

    useEffect(() => {

        setSizeTrace(item.traceStyle["line-width"]);
        setColorTrace(item.traceStyle["line-color"]);
        setPointilleTrace(item.traceStyle["line-dasharray"]);

        setIsActivePointilleTrace(transformPointilleTrace(item.traceStyle["line-dasharray"]))

    }, [openAbsoluteMenuSection])


    function changePointille(event: any, value: number) {

        var map = (window as any).$map;

        let from = item.traceStyle["line-dasharray"];

        const choix = [[1], [1, 1], [3, 2]];

        item.traceStyle["line-dasharray"] = choix[value];

        var l = map.getStyle().layers

        const myLayers = l.filter((x: any) => x.id === idTrace);

        myLayers.forEach((element: any) => {
            map.setPaintProperty(element.id, "line-dasharray", choix[value])
        });

        setIsActivePointilleTrace(value);
        $('.trace-type-div').removeClass("active");
        event.currentTarget.classList.add('active');

        let action = createOneValueItinerairetAction({
            target: "trace-pointille",
            item: item,
            from,
            to: item.traceStyle["line-dasharray"]
        });

        history.add(action);

    }

    function handleColor(color: any, event: any) {

        let from = item.traceStyle["line-color"];

        item.traceStyle["line-color"] = color.hex;

        var map = (window as any).$map;
        var l = map.getStyle().layers

        const myLayers = l.filter((x: any) => x.id === idTrace);

        myLayers.forEach((element: any) => {
            map.setPaintProperty(element.id, "line-color", color.hex)
        });

        //To reload component
        setColorTrace(color.hex);

        let action = createOneValueItinerairetAction({
            target: "trace-color",
            item: item,
            from,
            to: color.hex
        });

        history.add(action);
    }

    return (
        <div className='traces-marqueurs-elem'>
            {/*<div className="close-cont">
                <button className="btn-with-nothing" onClick={() => { if (setOpenAbsoluteMenuSection != null) setOpenAbsoluteMenuSection('') }} >
                    <img className="icone-button-main" src={process.env.REACT_APP_PUBLIC_URL + "/images/icone-menu/croix.svg"}></img>
                </button>
            </div>*/}
            <div>

                <h3 className="trace-title">Tracé du parcours</h3>
                <div className="texte-abs-section">Choisissez votre tracé, son épaisseur et sa couleur...</div>
                <div className="trace-type">
                    <div className={"trace-type-div " + (isActivePointilleTrace === 0 ? "active" : "")} onClick={(e) => changePointille(e, 0)}>
                        <svg viewBox="0 0 30 1" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0" y1="1" x2="30" y2="1" stroke="black" strokeWidth="3" />
                        </svg>
                    </div>
                    <div className={"trace-type-div " + (isActivePointilleTrace === 1 ? "active" : "")} onClick={(e) => changePointille(e, 1)}>
                        <svg viewBox="0 0 30 1" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0" y1="1" x2="30" y2="1" stroke="black" strokeDasharray="2" strokeWidth="3" />
                        </svg>
                    </div>
                    <div className={"trace-type-div " + (isActivePointilleTrace === 2 ? "active" : "")} onClick={(e) => changePointille(e, 2)}>
                        <svg viewBox="0 0 30 1" xmlns="http://www.w3.org/2000/svg">
                            <line x1="0" y1="1" x2="30" y2="1" stroke="black" strokeDasharray="4" strokeWidth="3" />
                        </svg>
                    </div>
                </div>

                <OpacitySliderTrace openAbsoluteMenuSection={openAbsoluteMenuSection} />

                <h3 className="trace-title">Couleur du tracé</h3>
                <div className="trace-color">
                    {(isDesktop || isTablet) && <ChromePicker
                        color={colorTrace}
                        onChange={handleColor} disableAlpha={true} />}

                    {((isMobile && !isTablet)) && <CompactPicker
                        color={colorTrace}
                        onChange={handleColor} />}
                </div>


            </div>

        </div>
    )
}

function OpacitySliderTrace(props: any) {

    //Use to make reload component
    const openAbsoluteMenuSection = props.openAbsoluteMenuSection;

    const { mapListTrace, history } = useContext(PageContext);

    const idTrace = openAbsoluteMenuSection.slice(openAbsoluteMenuSection.lastIndexOf('-') + 1);
    const item = mapListTrace.find(item => item.id === idTrace);

    var [opacityValue, setOpacityValue] = useState([item.traceStyle["line-width"]]);

    useEffect(() => {
        setOpacityValue([item.traceStyle["line-width"]]);
    }, [openAbsoluteMenuSection])
    useEffect(() => {
        setOpacityValue([item.traceStyle["line-width"]]);
    }, [item.traceStyle["line-width"]]);

    function weightChange(value: number[]) {

        setOpacityValue(value);
        var map = (window as any).$map;

        let from = item.traceStyle["line-width"];

        item.traceStyle["line-width"] = value[0];

        var l = map.getStyle().layers

        const myLayers = l.filter((x: any) => x.id === idTrace);

        myLayers.forEach((element: any) => {
            map.setPaintProperty(element.id, "line-width", value[0])
        });

        let action = createOneValueItinerairetAction({
            target: "trace-size",
            item: item,
            from,
            to: item.traceStyle["line-width"]
        });

        history.add(action);
    }

    return (
        <div>
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <h3 className="trace-title" style={{ marginTop: 0 }}>Epaisseur tracé </h3>
                <div style={{
                    marginLeft: '5px'
                }}
                >{opacityValue}</div>
            </div>
            <div
                style={{
                    display: "flex",
                    margin: "10px 0",
                    alignItems: "center"
                }}
            >

                <Range
                    step={1}
                    min={1}
                    max={10}
                    values={opacityValue}
                    onChange={(values) => weightChange(values)}
                    renderTrack={({ props, children }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: '4px',
                                width: '90%',
                                backgroundColor: '#000000'
                            }}
                        >
                            {children}
                        </div>
                    )}
                    renderThumb={({ props }) => (
                        <div
                            {...props}
                            style={{
                                ...props.style,
                                height: '18px',
                                width: '18px',
                                border: '1px solid #2B2827',
                                borderRadius: '50%',
                                backgroundColor: '#FFFFFF'
                            }}
                        />
                    )} />

            </div>
        </div>
    );
}

function Slider(props: any) {

    var fn = props.fn;
    var refSize = [props.refSize];
    var min = props.min;
    var max = props.max;

    const { isLandscape } = useMobileOrientation();

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                flexWrap: "wrap",
                margin: "10px",
                alignItems: "center"
            }}
        >
            <Range
                step={1}
                min={min}
                max={max}
                values={refSize}
                onChange={(values) => fn(values)}
                renderTrack={({ props, children }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '4px',
                            width: (isDesktop || isTablet || (isMobile && isLandscape)) ? '90px' : '150px',
                            backgroundColor: '#000000'
                        }}
                    >
                        {children}
                    </div>
                )}
                renderThumb={({ props }) => (
                    <div
                        {...props}
                        style={{
                            ...props.style,
                            height: '18px',
                            width: '18px',
                            border: '1px solid #2B2827',
                            borderRadius: '50%',
                            backgroundColor: '#FFFFFF'
                        }}
                    />
                )} />
        </div>
    );
}
